var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('BTable', {
    staticClass: "omni-table-small",
    attrs: {
      "small": "",
      "stacked": "",
      "items": _vm.tableItems,
      "fields": _vm.tableFields
    },
    scopedSlots: _vm._u([_vm._l(_vm.tableFields, function (field) {
      return {
        key: `cell(${field.key})`,
        fn: function (data) {
          return [field.key === 'invoices' ? _vm._t(`cell(${field.key})`, function () {
            return _vm._l(data.value, function (value, index) {
              return _c('span', {
                key: index
              }, [value.link ? _c('a', {
                attrs: {
                  "href": value.link,
                  "target": "_blank"
                }
              }, [_vm._v(_vm._s(value.txt)), _c('br')]) : _c('span', [_vm._v(_vm._s(value.txt)), _c('br')])]);
            });
          }) : _vm._t(`cell(${field.key})`, function () {
            return [_vm._v(" " + _vm._s(_vm.formatValue(data.item[field.key])) + " ")];
          }, null, data)];
        }
      };
    })], null, true)
  });

}
var staticRenderFns = []

export { render, staticRenderFns }